var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"socket-text-content"},[(!_vm.connected)?_c('div',[_vm._v("Connecting...")]):_c('div',_vm._l((_vm.displayMessages),function(message,index){return _c('p',{key:index,staticClass:"ma-0 pa-0"},[_vm._v(" "+_vm._s(message)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }